import { render, staticRenderFns } from "./comp_BookEditorInput-DatePicker.vue?vue&type=template&id=3b3bb67a&scoped=true&"
import script from "./comp_BookEditorInput-DatePicker.vue?vue&type=script&lang=js&"
export * from "./comp_BookEditorInput-DatePicker.vue?vue&type=script&lang=js&"
import style0 from "./comp_BookEditorInput-DatePicker.vue?vue&type=style&index=0&id=3b3bb67a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3bb67a",
  null
  
)

export default component.exports